import { AuthGuard } from '../services/user/auth.guard';
import { FeatureFlagGuard } from '../guards/feature-flag.guard';
import { ConnectAccountsAccessGuard } from '../guards/connect-accounts-access.guard';
import { FEATURE_FLAGS } from '../services/posthog.service';

/**
 * The gate chain protecting /connections, in one place so a test can assert it.
 *
 * It lives here rather than inline in app-routing.module.ts for one reason:
 * importing that module into a spec pulls every `loadChildren` chunk into the
 * Karma bundle and exhausts the Node heap, so the route's `canActivate` array
 * was unassertable — and a review proved the consequence, by deleting
 * ConnectAccountsAccessGuard from the route and watching all 54 specs stay
 * green. A one-token deletion removed the whole authorisation layer with no
 * test signal, and the menu gate would have hidden the entry well enough to
 * mask it in manual testing too. Only a direct URL would have shown it.
 *
 * This file imports no lazy routes, so a spec can import it for the price of
 * three guard classes.
 *
 * Order matters and is asserted. AuthGuard first (are you signed in),
 * FeatureFlagGuard second (is the feature rolled out to this salon),
 * ConnectAccountsAccessGuard last (may THIS stylist take part) — the last one
 * is the only one that may present an explanatory notice, and there is no
 * point explaining a revoked permission to a salon that never had the feature
 * switched on.
 */
export const CONNECTIONS_ROUTE_GATES = [
  AuthGuard,
  FeatureFlagGuard,
  ConnectAccountsAccessGuard,
];

export const CONNECTIONS_ROUTE_DATA = {
  featureFlag: FEATURE_FLAGS.connectableAccounts,
};
